"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const MapSideBarPanel_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapSideBarPanel.vue"));
const AgronomicInsightRankTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/AgronomicInsights/AgronomicInsightRankTag.vue"));
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let MapSideBarPanelAgronomicInsights = class MapSideBarPanelAgronomicInsights extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.controllerColor = new ColorLibController_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 70, 70);
    }
    generateColoRank(rank) {
        return this.controllerColor.getRankColor(rank.toString());
    }
    generateColoRankHLT(rank) {
        return this.controllerColor.getDiseasesColor(rank.toString());
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelAgronomicInsights.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelAgronomicInsights.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelAgronomicInsights.prototype, "metricAgInsights", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelAgronomicInsights.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelAgronomicInsights.prototype, "defaultMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelAgronomicInsights.prototype, "defaultIcon", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelAgronomicInsights.prototype, "polygonSelectedItem", void 0);
MapSideBarPanelAgronomicInsights = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { RankTag: AgronomicInsightRankTag_vue_1.default, MapSideBarPanel: MapSideBarPanel_vue_1.default },
    })
], MapSideBarPanelAgronomicInsights);
exports.default = MapSideBarPanelAgronomicInsights;
